export default {
    carregando: false,
    items: [],
    ordenacao: [],
    selecionado: {}
}